import EventPublisher from "../utils/EventPublisher";
import UIInteractionEvents from "../constants/events/UIInteractionEvents";
import ActionResultEvents from "../constants/events/ActionResultEvents";
import {GOOGLE_API_KEY} from "../constants/ConfigFromBuildEnvironment";

class AsyncLibraryLoadActions {

    //TODO - move FB async load into here and adjust login/logout buttons to wait on it

    constructor() {
        EventPublisher.subscribe(UIInteractionEvents.GOOGLE_API_LIB_REQUIRED, this.handleLibLoad);
    }

    handleLibLoad = (topic, data) => {
        const existingScript = document.getElementById("googlePlacesScript");
        if (!existingScript) {
            const script = document.createElement("script");
            script.src = "https://maps.googleapis.com/maps/api/js?key="+GOOGLE_API_KEY+"&libraries=places";
            script.id = "googlePlacesScript";
            script.onload = () => {EventPublisher.publish(ActionResultEvents.GOOGLE_LIB_LOADED, {});};
            document.body.appendChild(script);
        } else {
            EventPublisher.publish(ActionResultEvents.GOOGLE_LIB_LOADED, {});
        }
    };

}

export default new AsyncLibraryLoadActions();
